import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ContextsContextsService } from 'src/app/services/contexts-services/contexts-contexts-services/contexts-contexts.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SecurityService } from 'src/app/services/security-service/security.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { EMPTY } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-contexts-new-context-creation-card',
  templateUrl: './contexts-new-context-creation-card.component.html',
  styleUrls: ['./contexts-new-context-creation-card.component.scss']
})
export class ContextsNewContextCreationCardComponent implements OnInit, OnDestroy {

  centerList;
  showButton: boolean;
  addNewContextSubscription: Subscription;
  basicDataForm = new FormGroup({
    name: new FormControl(null, Validators.required),
    active: new FormControl(true),
    selectedCenter: new FormControl(null, Validators.required),
    context: new FormControl({value: null, disabled: true}, Validators.required)
  });

  constructor(private contextsService: ContextsContextsService,
    private userStorageService: UserStorageService,
    private securityService: SecurityService,
    private snackbarService: SnackBarService,
    private router: Router,
    private spinnerService: SpinnerService,
    private activatedRoute: ActivatedRoute) {
      this.showButton = true;
    }

  ngOnInit() {
    this.centerList = this.userStorageService.getCenterList();
    this.randomContext();
  }

  public addNewContext() {
    this.showButton = false;
    this.spinnerService.show('apisecret-new-spinner');
    const validation = this.validateForm();
    if (validation === true) {
      this.addNewContextSubscription = this.contextsService.addNewContext(this.basicDataForm.get('active').value, this.basicDataForm.get('name').value, this.getSelectedCenter(), this.basicDataForm.get('context').value).pipe(
        tap(o => this.showButton = true),
        tap(o => this.spinnerService.hide('context-new-spinner')),
        tap(o => this.snackbarService.open('apisecrets-page.snackbar messages.add apisecret success', 'success')),
        tap(o => this.router.navigate(['../contexts'], { relativeTo: this.activatedRoute.parent })),
        catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
      ).subscribe();
    } else {
      this.showButton = true;
      this.spinnerService.hide('context-new-spinner');
      this.snackbarService.open(validation, 'error');
    }
  }

  public randomContext() {
    this.basicDataForm.patchValue({
      context: this.securityService.genRandomToken()
    });
  }

  public cancelContext() {
    this.router.navigate(['../contexts'], { relativeTo: this.activatedRoute.parent });
  }

  public validateForm() {
    if (!this.basicDataForm.get('name').valid) {
      return 'apisecrets-page.snackbar messages.name apisecret error';
    } else if (!this.basicDataForm.get('selectedCenter').value) {
      return 'apisecrets-page.snackbar messages.selected center apisecret error';
    } else {
      return true;
    }
  }

  public getSelectedCenter() {
    if (this.centerList && this.centerList.length > 0) {
      if (this.basicDataForm.get('selectedCenter').value) {
        return this.basicDataForm.get('selectedCenter').value.InternalId;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  ngOnDestroy() {
    if (this.addNewContextSubscription) { this.addNewContextSubscription.unsubscribe(); }
  }
}
